import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import MessageTemplatesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/message-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'message_templates_list',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'message_templates_list',
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
          component: MessageTemplatesHome,
        },
      ],
    },
  ],
};
